import React from "react";
import { Shuffle } from "lucide-react";
import { GhostButton } from "@/shared/components/ui-kit";
import BuddyAvatar from "./BuddyAvatar";
import { glyphSeed, uniqueCreature } from "./glyph";
import type { AvatarCustomizerProps } from "./AvatarCustomizer";

export default function AgentAvatarControls({ seed, hue = 210, occupiedAvatars = [], onChange }: AvatarCustomizerProps) {
  return (
    <div className="flex items-center gap-4">
      <BuddyAvatar seed={seed} size={64} ring />
      <GhostButton onClick={() => onChange({ ...uniqueCreature(glyphSeed(), Math.floor(Math.random() * 360), [...occupiedAvatars, { seed, hue }]), avatar: null })}>
        <Shuffle className="w-3.5 h-3.5" strokeWidth={1.75} /> Shuffle avatar
      </GhostButton>
    </div>
  );
}
